import type { ReactNode } from "react";

import { formatMessage, t } from "../../lib/i18n";

interface BulkActionBarProps {
  count: number;
  onClear: () => void;
  children: ReactNode;
}

/**
 * Floating action bar shown above a table when one or more rows are selected.
 * Children are the contextual action buttons.
 */
export function BulkActionBar({ count, onClear, children }: BulkActionBarProps) {
  if (count === 0) return null;
  return (
    <div className="bulk-action-bar" role="region" aria-label="Bulk actions">
      <div className="bulk-action-bar__count">
        {formatMessage("common.bulk.selected", { count: String(count) })}
      </div>
      <div className="bulk-action-bar__actions">{children}</div>
      <button
        type="button"
        className="bulk-action-bar__clear"
        onClick={onClear}
      >
        {t("common.bulk.clear")}
      </button>
    </div>
  );
}
